import { Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { HttpService } from '../http.service';
import { HttpErrorHandlerService } from '../http-error-handler.service';

export interface PremiumChatIntentResponse {
  success: boolean;
  tokenRef: string;
  paymentIntent: string;
  customer: string;
  ephemeralKey: string;
  paymentMethods: any[];
  amount: number;
}

export interface PremiumChatCheckoutResponse {
  success: boolean;
  session: { id: string; client_secret: string };
}

export interface PremiumChatAmountResponse {
  success: boolean;
  amount: number;
  premium_chat_unlocked: boolean;
}

/**
 * Servicio API para pagos de chat premium.
 * Endpoints:
 *   GET  /payment/premium-chat/{conversationId}/amount
 *   POST /payment/premium-chat/{conversationId}/intent
 *   POST /payment/premium-chat/{conversationId}/checkout-session
 */
@Injectable({ providedIn: 'root' })
export class PremiumChatService {
  constructor(
    private http: HttpService,
    private errorHandler: HttpErrorHandlerService,
  ) {}

  /**
   * Obtiene el importe del chat premium para una conversación.
   */
  getAmount(conversationId: number): Observable<PremiumChatAmountResponse> {
    return this.http.get<PremiumChatAmountResponse>(`payment/premium-chat/${conversationId}/amount`).pipe(
      catchError(err => this.errorHandler.handleError(err)),
    );
  }

  /**
   * Crea un PaymentIntent para pago nativo (PaymentSheet).
   */
  createIntent(conversationId: number): Observable<PremiumChatIntentResponse> {
    return this.http.post(`payment/premium-chat/${conversationId}/intent`, {}).pipe(
      map((res: any) => res),
      catchError(err => this.errorHandler.handleError(err)),
    );
  }

  /**
   * Crea una Checkout Session para pago web (Embedded Checkout).
   */
  createCheckoutSession(conversationId: number): Observable<PremiumChatCheckoutResponse> {
    return this.http.post(`payment/premium-chat/${conversationId}/checkout-session`, {}).pipe(
      map((res: any) => res),
      catchError(err => this.errorHandler.handleError(err)),
    );
  }
}
